import { render, staticRenderFns } from "./criar-nota.vue?vue&type=template&id=b9d20416&"
import script from "./criar-nota.vue?vue&type=script&lang=js&"
export * from "./criar-nota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports